import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useWholesaleApiContext } from '~/hooks/useWholesaleApiContext';

export const useDeliveryEstimates = (
  products: Record<string, { quantity: number }>,
  options?: Pick<UseQueryOptions, 'enabled'>,
) => {
  const { consignmentClientApi, bearerToken } = useWholesaleApiContext();

  return useQuery({
    queryKey: ['deliveryEstimates', products],
    queryFn: async () => {
      const result = await consignmentClientApi().getDeliveryEstimates.mutation({
        headers: { authorization: bearerToken },
        body: { data: { products } },
      });

      if (result.status !== 200) {
        throw new Error('Failed to fetch delivery estimates');
      }

      return result.body.data;
    },
    enabled: (options?.enabled ?? true) && Boolean(bearerToken),
  });
};
